import { Trans } from '@lingui/macro';
import SearchIcon from 'assets/icons/SearchIcon.svg';
import WifiIcon from 'assets/icons/WifiIcon.svg';
import useIsMobileLayout from 'hooks/useIsMobileLayout';
import { useScreenSizeRatio } from 'hooks/useScreenSizeRatio';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'state/hooks';
import { usePhoneboothState } from 'state/phonebooth/hooks';
import { updatePhoneboothState, updateScreenCursorState } from 'state/phonebooth/slice';

import { usePhoneboothContext } from '..';
import ScreenButton from '../common/ScreenButton';
import Transmission from '../Transmission/Transmission';
import * as S from './HomeScreen.styles';

const HomeScreen: React.FC = () => {
  const { transmission } = usePhoneboothContext();

  const sizeRatio = useScreenSizeRatio();
  const dispatch = useAppDispatch();
  const isMobileLayout = useIsMobileLayout();

  const state = usePhoneboothState();

  const navigate = useNavigate();

  if (state === 'transmitting') {
    return (
      <S.TransmittingScreen>
        <S.Back
          sizeRatio={sizeRatio}
          onBack={() => {
            transmission.stop();
            dispatch(updatePhoneboothState('home'));
          }}
        />
        <Transmission
          transmission={transmission}
          title={'TRANSMISSION #1'}
          author={'Binary'}
          onReplayButtonEnter={() => dispatch(updateScreenCursorState('pointer'))}
          onReplayButtonLeave={() => dispatch(updateScreenCursorState('hover'))}
        />
      </S.TransmittingScreen>
    );
  }

  if (state === 'receiveTransmission') {
    return (
      <S.ReceiveTransmissionWrapper sizeRatio={sizeRatio}>
        <Trans>Incoming call...</Trans>
      </S.ReceiveTransmissionWrapper>
    );
  }

  return (
    <S.ButtonsWrapper sizeRatio={sizeRatio}>
      <ScreenButton
        label="Transmission"
        icon={WifiIcon}
        sizeRatio={sizeRatio}
        onClick={() => {
          if (isMobileLayout) {
            dispatch(updatePhoneboothState('transmitting'));
            transmission.play();
          } else {
            dispatch(updatePhoneboothState('receiveTransmission'));
          }
        }}
      />
      <ScreenButton
        label="Status"
        icon={SearchIcon}
        sizeRatio={sizeRatio}
        onClick={() => {
          dispatch(updatePhoneboothState('status'));
          navigate('/status');
        }}
      />
    </S.ButtonsWrapper>
  );
};

export default HomeScreen;
